module.exports = __webpack_public_path__ + "img/welding.e947dd60.webp";